import { buildSceneReaderContext } from '../contexts/scenereader-context';

/**
 * Loop Manager for SceneReader operations.
 * Evaluates image queries and coordinates SceneReader worker integrations.
 */
export async function executeSceneReaderLoop(seedPrompt: string, imageBase64?: string): Promise<string> {
    console.log(`[SceneReader Loop Engine] Evaluating image request for: "${seedPrompt}"`);
    
    let context = await buildSceneReaderContext(seedPrompt, imageBase64);
    
    // Quality Control / Loop Evaluation
    const userWantsDeepAnalysis = seedPrompt.toLowerCase().includes("deep analysis") || seedPrompt.toLowerCase().includes("thorough");
    
    if (userWantsDeepAnalysis && context.includes("Here is the analysis data")) {
        context += `\n[LOOP-ENGINEERING INJECTION: The user has requested a deep, thorough analysis. Expand on the semantic meaning of the tags and categories. Discuss the lighting, composition, and what story the image might be telling.]\n`;
    }

    return context;
}
